import { useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Landing from "@/pages/Landing";
import { Loader2 } from "lucide-react";

export default function RootRoute() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }
  if (user) {
    return (
      <Layout>
        <Home />
      </Layout>
    );
  }
  return <Landing />;
}
